import { createContext, useContext, useEffect } from 'react';
import { FCWithChildren } from 'helpers/types/FCWithChidren';
import { useMergeState } from 'hooks/useMergeState';

interface BrowserContext {
  isMobileView: boolean;
  isDesktopView: boolean;
}

const BrowserContext = createContext<BrowserContext>({
  isMobileView: false,
  isDesktopView: false,
});

export const BrowserProvider: FCWithChildren<{}> = ({ children }) => {
  const [state, setState] = useMergeState<{
    isMobileView: boolean;
    isDesktopView: boolean;
  }>({ isMobileView: false, isDesktopView: false });

  const context = {
    ...state,
  };

  useEffect(() => {
    function handleStateChange(event: MediaQueryList | MediaQueryListEvent) {
      const isMobileView = event.matches;
      setState({
        isMobileView,
        isDesktopView: !isMobileView,
      });
    }

    const query = window.matchMedia('(max-width: 640px)');

    handleStateChange(query);

    query.addEventListener('change', handleStateChange);

    return () => query.removeEventListener('change', handleStateChange);
    /**
     * We don't want to re-render this and it works as intended across state changes
     * Likely due to eslint not detecting `setState` as a safe dependency to ignore
     */
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <BrowserContext.Provider value={context}>
      {children}
    </BrowserContext.Provider>
  );
};

export const useBrowserContext = () => {
  const context = useContext<BrowserContext>(BrowserContext);

  if (!context)
    throw new Error(
      '----- useBrowserContext must be used in a BrowserProvider -------',
    );

  return context;
};
